import { LocaleContextType } from "./types";
import { createContext } from "react";
import { locales } from "./locales";

export const localeContext = createContext<LocaleContextType>({
  localesData: locales.getLocales(),
  currentLocale: locales.getLocales()[0],
  setCurrentLocale: () => undefined
});
